import React from 'react';

function Works() {
  return (
    <div className="img-column">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="img md-mb30">
              <img src="/dark/assets/imgs/works/projects/1/2.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="img">
              <img src="/dark/assets/imgs/works/projects/1/3.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Works;
